import React from 'react';

import Modal from './Modal';
import classNames from 'classnames';
import ThemedIcon from '@components/ThemedIcon';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactElement;
};

export function BaseModal({ isOpen, onClose, children }: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        className={classNames(
          'relative mx-auto w-full rounded-2xl bg-bg-secondary p-4 smd:p-10',
          onClose ? 'pt-[60px]' : undefined
        )}
      >
        {!!onClose && (
          <ThemedIcon
            name='circle-close'
            width={30}
            height={30}
            className='absolute right-4 top-4 cursor-pointer'
            onClick={onClose}
          />
        )}
        {children}
      </div>
    </Modal>
  );
}
